import React from "react"
import "./index.scss"
import Loader from "react-loaders"
import AnimatedLetters from "../AnimatedLetters"
import { useState } from "react"
import { useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGithub } from "@fortawesome/free-brands-svg-icons"
import { getDocs, collection } from "firebase/firestore/lite"
import { db } from "../../myFirebase"

const MyPorfolio = () => {
  const [letterClass, setLetterClass] = useState("text-animate")
  const [expandedProjectIndex, setExpandedProjectIndex] = useState(null)
  const [isLoadingPortfolio, setIsLoadingPortfolio] = useState(true)
  const [portfolioError, setPortfolioError] = useState("")
  // console.log(portfolioData);

  // Récupération des données du portfolio à partir du db
  const [portfolio, setPortfolio] = useState([])

  // implémentation de l'effet au survolement des lettres du titre
  useEffect(() => {
    const minuteur = setTimeout(() => {
      setLetterClass("text-animate-hover")
    }, 3000) //3s
    return () => {
      clearTimeout(minuteur)
    }
  }, [])

  // Appel de la methode getPortfolio
  useEffect(() => {
    getPortfolio()
  }, [])

  const getPortfolio = async () => {
    try {
      setIsLoadingPortfolio(true)
      setPortfolioError("")

      const requetePortfolio = await getDocs(collection(db, "portfolio"))
      // request type : querySnapshot ***
      // console.log(requetePortfolio);
      setPortfolio(requetePortfolio.docs.map((doc) => doc.data()))
    } catch (error) {
      setPortfolio([])
      setPortfolioError(
        "Impossible de charger les projets pour le moment. Veuillez reessayer plus tard."
      )
    } finally {
      setIsLoadingPortfolio(false)
    }
  }

  // Test de fonctionnement
  // console.log(portfolio);

  const toggleProjectDetails = (index) => {
    setExpandedProjectIndex((currentIndex) =>
      currentIndex === index ? null : index
    )
  }

  const handleProjectCardInteraction = (index) => {
    if (window.matchMedia("(max-width: 1200px)").matches) {
      toggleProjectDetails(index)
    }
  }

  const visiblePortfolio = portfolio.filter(
    (portfolioObject) => portfolioObject.showOnPortfolio !== false
  )

  const genererPortfolio = (portfolio) => {
    return (
      <div className="images-container">
        {portfolio.map((portfolioObject, index) => {
          const technologies =
            portfolioObject.technologies ||
            portfolioObject.technoligies ||
            "Non precise"
          const gitHubLink = portfolioObject.gitHubLink?.trim()
          const websiteLink = portfolioObject.websiteLink?.trim()
          const hasActionLink = Boolean(gitHubLink || websiteLink)
          const isExpanded = expandedProjectIndex === index
          const detailsId = `project-details-${index}`

          return (
            <div
              className={`image-box ${isExpanded ? "is-open" : ""}`}
              key={index}
              role="button"
              tabIndex={0}
              aria-expanded={isExpanded}
              aria-controls={detailsId}
              onClick={() => handleProjectCardInteraction(index)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault()
                  handleProjectCardInteraction(index)
                }
              }}
            >
              <img
                src={portfolioObject.image}
                className="portfolio-image"
                alt="Projet"
              />
              <div className="contenu">
                <p className="card-kicker">Projet</p>
                <h2 className="titre">{portfolioObject.titre}</h2>
                <div id={detailsId} className="details-body">
                  <p className="description">{portfolioObject.description}</p>
                  <h4 className="technologie">Technologies : {technologies}</h4>
                  {hasActionLink && (
                    <div className="card-actions">
                      {gitHubLink && (
                        <a
                          className="lien-gitHub"
                          href={gitHubLink}
                          target="_blank"
                          rel="noreferrer"
                          aria-label={`Voir le code du projet ${portfolioObject.titre}`}
                          onClick={(event) => event.stopPropagation()}
                        >
                          <FontAwesomeIcon icon={faGithub} />
                          <span className="github-link-text">Voir le code</span>
                        </a>
                      )}
                      {websiteLink && (
                        <button
                          className="btn"
                          onClick={(event) => {
                            event.stopPropagation()
                            window.open(
                              websiteLink,
                              "_blank",
                              "noopener,noreferrer"
                            )
                          }}
                        >
                          Voir le projet
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  const renderPortfolioContent = () => {
    if (isLoadingPortfolio) {
      return (
        <div className="portfolio-state" role="status" aria-live="polite">
          Chargement des projets...
        </div>
      )
    }

    if (portfolioError) {
      return (
        <div className="portfolio-state portfolio-state-error" role="alert">
          {portfolioError}
        </div>
      )
    }

    if (portfolio.length === 0) {
      return (
        <div className="portfolio-state portfolio-state-empty" role="status">
          Aucune donnee de projet n&apos;est disponible pour le moment.
        </div>
      )
    }

    if (visiblePortfolio.length === 0) {
      return (
        <div className="portfolio-state portfolio-state-empty" role="status">
          Aucun projet visible n&apos;est disponible pour le moment.
        </div>
      )
    }

    return genererPortfolio(visiblePortfolio)
  }

  return (
    <>
      <div className="conteneur portfolio-page">
        <h1 className="page-title">
          <AnimatedLetters
            letterClass={letterClass}
            strArray={"Portfolio".split("")} //construction du tableau
            index={15}
          />
        </h1>
        <section
          className="portfolio-intro"
          aria-label="Introduction du portfolio"
        >
          <p className="portfolio-intro-tag">
            Quelques projets et mini-projets
          </p>
          <h2 className="portfolio-intro-title">
            Une sélection ciblée de réalisations menées jusqu&apos;ici.
          </h2>
          <p className="portfolio-intro-text">
            Cette section présente quelques projets et/ou mini-projets que
            j&apos;ai réalisés jusqu&apos;à maintenant. Il s&apos;agit d&apos;un
            aperçu non exhaustif, choisi pour illustrer mon approche: clarté
            fonctionnelle, qualité du code et expérience utilisateur soignée.
          </p>
        </section>
        <section className="projects-bg-card" aria-label="Galerie des projets">
          {renderPortfolioContent()}
        </section>
      </div>
      <Loader type="pacman"></Loader>
    </>
  )
}

export default MyPorfolio
